import { call, put, takeLatest } from "redux-saga/effects";
import {
  validateProductNameNinError,
  validateProductNameNinStart,
  validateProductNameNinSucceded,
} from "./slice";

import { removeWhitespace } from "Formatting/index";
import { updateProductStart } from "Store/cart/cartSlice";
import { CART_RESOURCE_ROOT } from "Utils/apiUtils";
import { createRequest } from "Utils/requestUtils";
import { isAxiosError } from "axios";
import { INSURANCE_NAME_VALUE } from "../interfaces/products/index";
import { PersonInfo, ProductNameNinValidationErrorType } from "./interfaces";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* validateProductNameNin({
  payload,
}: ReturnType<typeof validateProductNameNinStart>) {
  try {
    const url = `${CART_RESOURCE_ROOT}/products/${payload.productId}/validateNameAndNin`;
    const personalia: PersonInfo = {
      ...payload.personInfo,
      nin: removeWhitespace(payload.personInfo.nin),
    };
    yield call(createRequest, {
      method: "post",
      requestBody: {
        ...personalia,
        verifyNotSameAsCustomer: payload.verifyNotSameAsCustomer,
      },
      url,
      open: false,
    });
    yield put(validateProductNameNinSucceded(payload.productId));
    if (
      payload.updatedProduct &&
      (payload.updatedProduct.name === INSURANCE_NAME_VALUE.NEW_CHILD ||
        payload.updatedProduct.name === INSURANCE_NAME_VALUE.AKA_CHILD)
    ) {
      yield put(updateProductStart(payload.updatedProduct));
      if (payload.childHealthProduct) {
        yield put(updateProductStart(payload.childHealthProduct));
      }
    }
  } catch (e) {
    const error: ProductNameNinValidationErrorType = isAxiosError(e)
      ? (e.response?.data.title as ProductNameNinValidationErrorType)
      : ProductNameNinValidationErrorType.UNKNOWN_ERROR;

    yield put(
      validateProductNameNinError({
        productId: payload?.productId,
        error,
      }),
    );
  }
}

export function* validateProductNameNinSaga(): Generator {
  yield takeLatest(validateProductNameNinStart, validateProductNameNin);
}
